import {
  getOrganisationAnalytics as getAnalytics,
  AnalyticsRange,
} from "../api/analyticsApi";
import { AnalyticsData } from "../types/types";

/**
 * Get organization analytics data
 * @param organisationId - Organization ID
 * @returns Promise<OrganisationAnalytics>
 */
export async function getOrganisationAnalytics(
  organisationId: string,
  options?: {
    range?: AnalyticsRange;
    startDate?: string;
    endDate?: string;
  }
): Promise<AnalyticsData> {
  try {
    const response = await getAnalytics(organisationId, options);
    return response;
  } catch (error) {
    console.error("Error fetching organisation analytics:", error);
    throw error;
  }
}
